<!--采购叫料-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          :allowClear="false"
          slot="organizationCode"
          :value.sync="queryParams.organizationCode"
          selectType="selectAssemble"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
          :disabled="isDisableOrganization"
        />
        <global-select
          slot="supplierCodeList"
          ref="supplierCodeRef"
          :value.sync="queryParams.supplierCodeList"
          selectType="selectMultipleSearch"
          requestApi="/mdm/mdmOrgSupplier/supplierBox"
          :selectItem="{ value: 'bringOutDataOne', label: 'label' }"
          searchParam="supplierName"
        />
        <global-select
          slot="statusList"
          :value.sync="queryParams.statusList"
          :selectData="statusList"
          selectType="selectMultipleFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <global-select
          slot="workOrderStatus"
          :value.sync="queryParams.workOrderStatus"
          :selectData="gdStatusList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <global-select
          slot="lbjType"
          :value.sync="queryParams.lbjType"
          :selectData="lbjTypeList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <global-select
          slot="sourceType"
          :value.sync="queryParams.sourceType"
          :selectData="sourceTypeList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" v-hasPermi="['mes:mesProcurementCallOrder:downloadDemand']" :loading="loading" @click="handleDownloadDemand">下载工单需求</a-button>
        <a-button type="primary" v-hasPermi="['mes:mesProcurementCallOrder:add']" :loading="loading" @click="handleAdd">新增</a-button>
        <a-button type="primary" v-hasPermi="['mes:mesProcurementCallOrder:push']" :loading="loading" :disabled="selectedRows.length < 1" @click="handlePushMaterial">下推叫料</a-button>
        <a-button type="primary" v-hasPermi="['mes:mesProcurementCallOrder:export']" :loading="loading" @click="handleExport">导出</a-button>
        <download-modal :apiFun="apiMesQueryTradeOrderExport" ref="download" />
        <purchase-order-add-modal ref="purchaseOrderAddModalRef" @closeModal="handleOk(true)" />
        <push-material-modal ref="pushMaterialModalRef" @closeModal="handleOk(true)" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @selectedRowChange="selectedRowChange"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }">
          <template slot="apptsNo" slot-scope="{ record, text }">
            <a @click="toDetails(record)" href="javascript:;">{{ text }}</a>
          </template>
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <!-- 期望交货日期 -->
          <template slot="demandDate" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text ? $moment(text).format('YYYY-MM-DD') : '' }}</span>
            <a-date-picker :allowClear="false" v-else style="width: 100%" v-model="record.demandDate" valueFormat="YYYY-MM-DD 00:00:00" />
          </template>
          <!-- 需求数量 -->
          <template slot="workOrderDemandQty" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input-number
              v-else
              style="width: 100%"
              v-model="record.workOrderDemandQty"
              :min="0.01"
              :max="999999"
              :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
              :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
            />
          </template>
          <span slot="operation" slot-scope="text">
            <a
              v-hasPermi="['mes:mesProcurementCallOrder:edit']"
              v-if="(!isEdit || currentId !== text.record.id)&&['NEW','PUSH_FAIL'].includes(text.record.status)"
              @click="handleEdit(text.record)">
              编辑
            </a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
            <a class="ml10" v-hasPermi="['mes:mesProcurementCallOrder:log']" @click="handleLog(text.record)">日志</a>
          </span>
        </ls-api-table>
      </div>
      <operation-log-model ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData, handleCopyFromExcel } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import rejectModal from '../../materialReservationManagement/materialReservationList/components/reject-modal.vue'
import appointmentTimeModal from '../../materialReservationManagement/materialReservationList/components/appointment-time-modal.vue'
import cacheRequest from '@/mixins/cacheRequest'
import { mapState } from 'vuex'
import purchaseOrderAddModal from './components/purchaseOrderAddModal.vue'
import pushMaterialModal from './components/pushMaterialModal.vue'
import {
  apiMesProcurementCallOrderEdit,
  apiMesProcurementCallOrderList,
  apiMesQueryTradeOrderExport,
  apiMesQueryTradeOrderSyncData
} from '@/api/scp/purchase/purchaseApi'
import { apiGetLog } from '@/api/mes/productionPrepare/teamManage'
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'

export default {
  name: 'PurchaseOrderMaterial',
  components: { DownloadModal, rejectModal, appointmentTimeModal, purchaseOrderAddModal, pushMaterialModal, OperationLogModel },
  mixins: [cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'; // 林氏产业园库存组织可
    }
  },
  data() {
    return {
      logLoading: false, // 日志loading
      logList: [], // 日志列表
      apiMesQueryTradeOrderExport,
      loading: false, // 请求loading
      isEdit: false,
      currentId: "",
      selectedRowKeys: [],
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMesProcurementCallOrderList, false),
        pageCurrent: true
      },
      statusList: [], // 状态列表
      lbjTypeList: [], // 零部件列表
      gdStatusList: [], // 工单状态列表
      sourceTypeList: [], // 采购下单来源列表
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        supplierCodeList: undefined,
        itemCode: undefined,
        demandDate: undefined,
        demandDateStart: undefined,
        demandDateEnd: undefined,
        wipEntityNameVal: undefined,
        statusList: ['NEW'], // 默认只显示新建的
        assemblyItemCode: undefined,
        workOrderStatus: undefined,
        callDocNumber: undefined,
        deliveryPlanOrder: undefined,
        lbjType: undefined,
        sourceType: undefined,
        createTime: undefined,
        createTimeStart: undefined,
        createTimeEnd: undefined
      },
      formList: [
        { label: '加工厂', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '供应商', decorator: ['supplierCodeList'], type: 'supplierCodeList' },
        { label: '物料编码', decorator: ['itemCode'], type: 'input' },
        {
          label: '期望到货日期',
          type: 'range',
          decorator: ['demandDate'],
          disposeFormat: {
            demandDateStart: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            demandDateEnd: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        { label: '工单号', decorator: ['wipEntityNameVal'], type: 'input' },
        { label: '状态', decorator: ['statusList'], type: 'statusList' },
        { label: '成品编码', decorator: ['assemblyItemCode'], type: 'input' },
        { label: '工单状态', decorator: ['workOrderStatus'], type: 'workOrderStatus' },
        { label: '叫料单号', decorator: ['callDocNumber'], type: 'input' },
        { label: '发货计划单号', decorator: ['deliveryPlanOrder'], type: 'input' },
        { label: '业务类型', decorator: ['lbjType'], type: 'lbjType' },
        { label: '来源类型', decorator: ['sourceType'], type: 'sourceType' },
        {
          label: '创建日期',
          type: 'range',
          decorator: ['createTime'],
          disposeFormat: {
            createTimeStart: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            createTimeEnd: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        }
      ],
      // 表格字段
      columns: [
        { title: '工厂', dataIndex: 'organizationName', align: 'center', width: 140 },
        { title: '状态', dataIndex: 'statusName', align: 'center', width: 100 },
        { title: '叫料单号', dataIndex: 'callDocNumber', align: 'center', width: 120 },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 120 },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 160, ellipsis: true },
        { title: '物料描述', dataIndex: 'itemDescription', align: 'center', width: 160, ellipsis: true },
        { title: '需求数量', dataIndex: 'workOrderDemandQty', scopedSlots: { customRender: 'workOrderDemandQty' }, align: 'center', width: 95 },
        { title: '已叫料数', dataIndex: 'callQty', align: 'center', width: 95 },
        { title: '发货数量', dataIndex: 'shipmentQuantity', align: 'center', width: 95 },
        { title: '收货数量', dataIndex: 'receivedQuantity', align: 'center', width: 95 },
        { title: '期望到货日期', dataIndex: 'demandDate', scopedSlots: { customRender: 'demandDate' }, align: 'center', width: 130 },
        { title: '收货子库', dataIndex: 'receiveSubLibrary', align: 'center', width: 100 },
        { title: '供应商编码', dataIndex: 'supplierCode', align: 'center', width: 140 },
        { title: '供应商名称', dataIndex: 'supplierName', align: 'center', width: 180 },
        { title: '单位', dataIndex: 'primaryUomCode', align: 'center', width: 80 },
        { title: '业务类型', dataIndex: 'lbjTypeName', align: 'center', width: 110 },
        { title: '工单号', dataIndex: 'wipEntityName', align: 'center', width: 125 },
        { title: '工单状态', dataIndex: 'workOrderStatusName', align: 'center', width: 100 },
        { title: '工单创建时间', dataIndex: 'workOrderCreateTime', align: 'center', width: 140 },
        { title: '计划完成时间', dataIndex: 'scheduledCompletionDate', align: 'center', width: 140 },
        { title: '成品编码', dataIndex: 'assemblyItemCode', align: 'center', width: 140 },
        { title: '成品名称', dataIndex: 'productName', align: 'center', width: 140 },
        { title: '成品规格描述', dataIndex: 'assemblyItemDescription', align: 'center', width: 160, ellipsis: true },
        { title: '工单套数', dataIndex: 'planQuantity', align: 'center', width: 90 },
        { title: 'BOM用量', dataIndex: 'quantityPerAssembly', align: 'center', width: 90 },
        { title: '发货计划单号', dataIndex: 'deliveryPlanOrder', align: 'center', width: 100 },
        { title: '交易订单号', dataIndex: 'tradeOrder', align: 'center', width: 90 },
        { title: '推单结果', dataIndex: 'pushDownResult', align: 'center', width: 100 },
        { title: '来源类型', dataIndex: 'sourceTypeName', align: 'center', width: 100 },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 90 },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 140 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 90 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
        {
          title: '操作',
          width: 95,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    this.cacheLookupRequest('MES_PROCUREMENT_CALL_TYPE', { lookupType: 'MES_PROCUREMENT_CALL_TYPE', current: 1, pageSize: 999 }, 'statusList')
    this.cacheLookupRequest('MES_JOB_STATUS', { lookupType: 'MES_JOB_STATUS', current: 1, pageSize: 999 }, 'gdStatusList')
    this.cacheLookupRequest('SCP_PLAN_PURCHASE_ORDER_LBJ_TYPE', { lookupType: 'SCP_PLAN_PURCHASE_ORDER_LBJ_TYPE', current: 1, pageSize: 999 }, 'lbjTypeList')
    this.cacheLookupRequest('SCP_PLAN_PURCHASE_ORDER_SOURCE_TYPE', { lookupType: 'SCP_PLAN_PURCHASE_ORDER_SOURCE_TYPE', current: 1, pageSize: 999 }, 'sourceTypeList')
  },
  mounted() {
    this.queryParams.organizationCode = this.organizationCodeOrigin
    this.onSearch()
  },
  methods: {
    // 下载工单需求
    handleDownloadDemand() {
      this.loading = true;
      apiMesQueryTradeOrderSyncData({ organizationCode: this.queryParams.organizationCode }).then(res => {
        if (res?.code === 200) {
          this.$message.success('下载工单需求成功')
          this.handleOk(true)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 供应商选择
    handleSupplierChange(val, list, record) {
      if(val && list?.length > 0) {
        const getSupplier = list.find(item => item.supplierCode === val)
        record.supplierName = getSupplier?.supplierName || ''
      }
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    // 操作日志弹窗
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show()
      apiGetLog({ id: row.id, type: 11 }).then(res => {
        if (res?.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    // 新增
    handleAdd() {
      this.$refs.purchaseOrderAddModalRef.show(this.queryParams.organizationCode)
    },
    // 下推物料
    handlePushMaterial() {
      const findNoAllow = this.selectedRows.find(item => !(['NEW', 'PUSH_FAIL'].includes(item.status)))
      if(findNoAllow) {
        this.$message.warning('请选择待新增或推单失败的单据推单')
        return;
      }
      this.$refs.pushMaterialModalRef.show(this.selectedRows)
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 编辑
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 保存
    handleSave(record) {
      if(!record?.workOrderDemandQty) {
        this.$message.warning('请输入需求数量')
        return;
      }
      this.loading = true;
      apiMesProcurementCallOrderEdit(record).then(res => {
        if (res?.code === 200) {
          this.$message.success('编辑成功')
          this.handleOk(true)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 取消
    handleCancel() {
      this.handleOk(true)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false;
      this.currentId = '';
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      handleCopyFromExcel('wipEntityName', 'wipEntityNameList', params) // 物料编码支持excel的copy查询
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        organizationCode: this.organizationCodeOrigin,
        supplierCodeList: undefined,
        itemCode: undefined,
        demandDate: undefined,
        demandDateStart: undefined,
        demandDateEnd: undefined,
        wipEntityNameVal: undefined,
        statusList: undefined,
        assemblyItemCode: undefined,
        workOrderStatus: undefined,
        callDocNumber: undefined,
        deliveryPlanOrder: undefined,
        lbjType: undefined,
        sourceType: undefined,
        createTime: undefined,
        createTimeStart: undefined,
        createTimeEnd: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
      if(this.$refs?.supplierCodeRef) this.$refs.supplierCodeRef.handleSearch('');
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
.pub-select{
  /deep/ .ant-select{
    width: 100%;
  }
}
</style>
